import { createAction } from 'redux-act'

const setCustomerCodeState = createAction<any>('club cart - set customer code state')
const toggleClubCardDrawer = createAction('club card - toggle club card drawer')

const setClubCardPropsToState = createAction<any>('club card - set club card props to state')

const setClubCardFail = createAction('club card - set club card fail')

export default {
  setCustomerCodeState,
  toggleClubCardDrawer,
  setClubCardPropsToState,
  setClubCardFail,
}
